import moment from 'moment';

export const DATE_FORMAT = 'DD MMMM yyyy';

export function utcToLocal(date?: Date) {
  if (!date) {
    return null;
  }
  
  return moment(date).isValid() && moment(date).year() > 1970
    ? moment.utc(date).local()
    : null;
}

export function formatDate(date?: Date | string, format = DATE_FORMAT, suffix?: string) {
  if (!date) {
    return null;
  }

  return moment(date).isValid() && moment(date).year() > 1970
    ? moment(date).format(DATE_FORMAT) + (suffix ?? '')
    : null;
}
